import { Proposal } from "generated/graphql";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import MoveToOnHoldIcon from "../../../../assets/images/movetoonhold-proposal.svg";
import useHoldProposal from "hooks/proposals/useHoldProposal";

export default function MoveProposalToOnHold({
  id,
  status,
}: {
  id: Proposal["id"];
  status: Proposal["status"];
}) {
  const [holdProposal] = useHoldProposal({ id });
  const validStatuses = [
    "SENT",
    "DRAFT",
    "CANCELED",
    "CLOSED_LOST",
    "CLOSED_WON",
    "OPEN",
    "CHANGE_ORDER",
    "NEW_VERSION",
  ];
  const isDisabled = !validStatuses.includes(status);

  return (
    <Tooltip title="Move to On Hold">
      <IconButton
        disabled={isDisabled}
        onClick={async () => {
          await holdProposal({
            variables: { id },
          });
        }}
      >
        <img
          src={MoveToOnHoldIcon}
          alt="Move To On Hold"
          style={{
            filter: isDisabled ? "invert(70%) hue-rotate(120deg)" : "invert(0%) hue-rotate(120deg)",
          }}
        />
      </IconButton>
    </Tooltip>
  );
}
